var _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDisconnectAccIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.9862 7.10384C5.03803 7.30018 4.15948 7.76946 3.46447 8.46447C2.52678 9.40215 2 10.6739 2 12C2 13.3261 2.52678 14.5979 3.46447 15.5355C4.40215 16.4732 5.67392 17 7 17H10C10.2652 17 10.5196 16.8946 10.7071 16.7071C10.8946 16.5196 11 16.2652 11 16C11 15.7348 10.8946 15.4804 10.7071 15.2929C10.5196 15.1054 10.2652 15 10 15H7C6.20435 15 5.44129 14.6839 4.87868 14.1213C4.31607 13.5587 4 12.7956 4 12C4 11.2044 4.31607 10.4413 4.87868 9.87868C5.44129 9.31607 6.20435 9 7 9H7.88236L5.9862 7.10384ZM9.88236 11H9C8.73478 11 8.48043 11.1054 8.29289 11.2929C8.10536 11.4804 8 11.7348 8 12C8 12.2652 8.10536 12.5196 8.29289 12.7071C8.48043 12.8946 8.73478 13 9 13H11.8824L9.88236 11ZM15.7668 12.6418L14.125 11H15C15.2652 11 15.5196 11.1054 15.7071 11.2929C15.8946 11.4804 16 11.7348 16 12C16 12.2356 15.9169 12.4626 15.7668 12.6418ZM13.8886 15.0062C13.6644 15.0314 13.454 15.1318 13.2929 15.2929C13.1054 15.4804 13 15.7348 13 16C13 16.2652 13.1054 16.5196 13.2929 16.7071C13.4804 16.8946 13.7348 17 14 17H15.8824L13.8886 15.0062ZM19.4715 16.3465L17.9654 14.8404C18.3967 14.6938 18.7931 14.4495 19.1213 14.1213C19.6839 13.5587 20 12.7956 20 12C20 11.2044 19.6839 10.4413 19.1213 9.87868C18.5587 9.31607 17.7956 9 17 9H14C13.7348 9 13.4804 8.89464 13.2929 8.70711C13.1054 8.51957 13 8.26522 13 8C13 7.73478 13.1054 7.48043 13.2929 7.29289C13.4804 7.10536 13.7348 7 14 7H17C18.3261 7 19.5979 7.52678 20.5355 8.46447C21.4732 9.40215 22 10.6739 22 12C22 13.3261 21.4732 14.5979 20.5355 15.5355C20.216 15.8551 19.8576 16.127 19.4715 16.3465ZM10.991 7.86598L10.134 7.00902C10.3497 7.03819 10.5514 7.13723 10.7071 7.29289C10.8628 7.44855 10.9618 7.65025 10.991 7.86598Z",
    fill: "#FF6666"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.0625,
    y: 4,
    width: 21,
    height: 1.5,
    rx: 0.75,
    transform: "rotate(45 6.0625 4)",
    fill: "#FF6666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisconnectAccIcon);
export default __webpack_public_path__ + "static/media/disconnect_acc_icon.5e689267a23e7e05d4a60fffc22b8cbb.svg";
export { ForwardRef as ReactComponent };